import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import type { ReactNode } from 'react';

interface HomeEmptyStateProps {
  children: ReactNode;
  title?: string;
  action?: ReactNode;
  favorites?: boolean;
}

export const HomeEmptyState = ({
  children,
  title,
  action,
  favorites = false,
}: HomeEmptyStateProps) => {
  const classes = useStyles();
  return (
    <Box className={favorites ? classes.favorites : classes.root}>
      {title && <Typography className={classes.title}>{title}</Typography>}
      {title ? (
        <Typography className={classes.body}>{children}</Typography>
      ) : (
        children
      )}
      {action}
    </Box>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    border: `1px dashed ${theme.palette.border}`,
    borderRadius: 8,
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
  favorites: {
    width: '100%',
    minHeight: 104,
    borderRadius: 8,
    border: `1px solid ${theme.palette.border}`,
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
  title: {
    color: theme.palette.text.primary,
    fontWeight: 700,
    marginBottom: theme.spacing(0.5),
  },
  body: {
    fontSize: '0.88rem',
    lineHeight: 1.45,
    marginBottom: theme.spacing(1),
  },
}));
